import { Link } from "react-router-dom";

export const NotFound =() => {
  return (
    <div className="container">
      <h2>Ошибка 404</h2>
      <p>Страница не найдена перейти на <Link className="btn btn-dark" to={'/'}> главную</Link></p>
    </div>
  );
}
